'use strict';exports.__esModule = true;exports.reset = exports.resetTranslate = exports.toggleAdditionalInfoTranslation = exports.toggleDescriptionTranslation = exports.detectAdditionalInfoLanguage = exports.translateAdditionalInfo = exports.detectDescriptionLanguage = exports.translateDescription = exports.sendCompanyContactUsForm = exports.closeCompanyContactModal = exports.openCompanyContactModal = exports.loadCompanySuccess = exports.loadCompanyProps = exports.loadOwnCompany = exports.loadCompany = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _services = require('../../services');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var

promise = _reduxLoop.Effects.promise;

var COMPANY_CONTACT_US_URL = 'messaging/contact-agency-personal';
var COMPANY_COMMUNITY_CONTACT_US_URL = 'messaging/contact-agency-personal-community-member';

var loadCompany = (0, _reduxAct.createAction)('/LOAD_COMPANY');
var loadCompanySuccess = (0, _reduxAct.createAction)('/LOAD_COMPANY_SUCCESS');
var loadCompanyFail = (0, _reduxAct.createAction)('/LOAD_COMPANY_FAIL');

var loadOwnCompany = (0, _reduxAct.createAction)('/LOAD_OWN_COMPANY');
var loadOwnCompanySuccess = (0, _reduxAct.createAction)('/LOAD_OWN_COMPANY_SUCCESS');
var loadOwnCompanyFail = (0, _reduxAct.createAction)('/LOAD_OWN_COMPANY_FAIL');

var loadCompanyProps = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS');
var loadCompanyPropsSuccess = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS_SUCCESS');
var loadCompanyPropsFail = (0, _reduxAct.createAction)('/LOAD_COMPANY_PROPS_FAIL');
var openCompanyContactModal = (0, _reduxAct.createAction)('/OPEN_COMPANY_CONTACT_MODAL');
var closeCompanyContactModal = (0, _reduxAct.createAction)('/CLOSE_COMPANY_CONTACT_MODAL');
var sendCompanyContactUsForm = (0, _reduxAct.createAction)('/SEND_COMPANY_CONTACT_US');
var sendCompanyContactUsFormSuccess = (0, _reduxAct.createAction)('/SEND_COMPANY_CONTACT_US_SUCCESS');
var sendCompanyContactUsFormFail = (0, _reduxAct.createAction)('/SEND_COMPANY_CONTACT_US_FAIL');
var translateDescription = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION');
var translateDescriptionSuccess = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_SUCCESS');
var translateDescriptionFail = (0, _reduxAct.createAction)('/TRANSLATE_DESCRIPTION_FAIL');
var translateAdditionalInfo = (0, _reduxAct.createAction)('/TRANSLATE_ADDITIONAL_INFO');
var translateAdditionalInfoSuccess = (0, _reduxAct.createAction)('/TRANSLATE_ADDITIONAL_INFO_SUCCESS');
var translateAdditionalInfoFail = (0, _reduxAct.createAction)('/TRANSLATE_ADDITIONAL_INFO_FAIL');
var detectDescriptionLanguage = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE');
var detectDescriptionLanguageSuccess = (0, _reduxAct.createAction)('/DETECT_DESCRIPTION_LANGUAGE_SUCCESS');
var detectAdditionalInfoLanguage = (0, _reduxAct.createAction)('/DETECT_ADDITIONAL_INFO_LANGUAGE');
var detectAdditionalInfoLanguageSuccess = (0, _reduxAct.createAction)('/DETECT_ADDITIONAL_INFO_LANGUAGE_SUCCESS');
var toggleDescriptionTranslation = (0, _reduxAct.createAction)('/TOGGLE_DESCRIPTION_TRANSLATION');
var toggleAdditionalInfoTranslation = (0, _reduxAct.createAction)('/TOGGLE_ADDITIONAL_INFO_TRANSLATION');
var resetTranslate = (0, _reduxAct.createAction)('/RESET_TRANSLATION');
var reset = (0, _reduxAct.createAction)('/RESET_COMPANY');

var initialState = {
  data: null,
  properties: null,
  loaded: false,
  loading: false,
  propertiesLoaded: false,
  propertiesLoading: false,
  error: null,
  propertiesError: null,
  mobileCompanyContactIsOpen: false,
  formSubmitting: false,
  formSubmitted: false,
  translatedDescriptionRequired: null,
  descriptionLoaded: false,
  showOriginalDescription: false,
  translatedDescriptionText: null,
  targetDescriptionLanguage: null,
  sourceDescriptionLanguage: null,
  translatedAdditionalInfoRequired: null,
  additionalInfoLoaded: false,
  showOriginalAdditionalInfo: false,
  translatedAdditionalInfoText: null,
  targetAdditionalInfoLanguage: null,
  sourceAdditionalInfoLanguage: null };


var translateDescriptionCall = function translateDescriptionCall(_ref) {var q = _ref.q,targetDescriptionLanguage = _ref.targetDescriptionLanguage,sourceDescriptionLanguage = _ref.sourceDescriptionLanguage;return _services.TranslationService.
  translate(q, targetDescriptionLanguage, sourceDescriptionLanguage).
  then(translateDescriptionSuccess).
  catch(translateDescriptionFail);};

var handleTranslateDescription = function handleTranslateDescription(state, _ref2) {var q = _ref2.q;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    descriptionLoading: true }),
  promise(translateDescriptionCall, {
    q: q,
    targetDescriptionLanguage: state.targetDescriptionLanguage,
    sourceDescriptionLanguage: state.sourceDescriptionLanguage }));};


var handleTranslateDescriptionSuccess = function handleTranslateDescriptionSuccess(state, action) {return Object.assign({},
  state, {
    translatedDescriptionText: action,
    descriptionLoading: false,
    descriptionLoaded: true });};


var handleTranslateDescriptionFail = function handleTranslateDescriptionFail(state) {return Object.assign({},
  state, {
    descriptionLoaded: false,
    translatedDescriptionText: null,
    showOriginalDescription: false });};


var translateAdditionalInfoCall =
function translateAdditionalInfoCall(_ref3) {var q = _ref3.q,targetAdditionalInfoLanguage = _ref3.targetAdditionalInfoLanguage,sourceAdditionalInfoLanguage = _ref3.sourceAdditionalInfoLanguage;return _services.TranslationService.
  translate(q, targetAdditionalInfoLanguage, sourceAdditionalInfoLanguage).
  then(translateAdditionalInfoSuccess).
  catch(translateAdditionalInfoFail);};

var handleTranslateAdditionalInfo = function handleTranslateAdditionalInfo(state, _ref4) {var q = _ref4.q;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    additionalInfoLoading: true }),
  promise(translateAdditionalInfoCall, {
    q: q,
    targetAdditionalInfoLanguage: state.targetAdditionalInfoLanguage,
    sourceAdditionalInfoLanguage: state.sourceAdditionalInfoLanguage }));};


var handleTranslateAdditionalInfoSuccess = function handleTranslateAdditionalInfoSuccess(state, action) {return Object.assign({},
  state, {
    translatedAdditionalInfoText: action,
    additionalInfoLoading: false,
    additionalInfoLoaded: true });};


var handleTranslateAdditionalInfoFail = function handleTranslateAdditionalInfoFail(state) {return Object.assign({},
  state, {
    additionalInfoLoaded: false,
    translatedAdditionalInfoText: null,
    showOriginalAdditionalInfo: false });};


var detectDescriptionCall = function detectDescriptionCall(_ref5) {var q = _ref5.q,locale = _ref5.locale;return _services.TranslationService.
  suggestStringLanguage(q, 0.7).
  then(function (detection) {
    if (detection) {
      return {
        targetDescriptionLanguage: locale,
        sourceDescriptionLanguage: detection.language,
        translatedDescriptionRequired: detection.language !== locale };

    }

    return { translatedDescriptionRequired: false };
  }).
  then(detectDescriptionLanguageSuccess);};

var handleDetectDescriptionLanguage = function handleDetectDescriptionLanguage(state, action) {
  if (!action.q || !action.q.length) {
    return Object.assign({},
    state, {
      translatedDescriptionRequired: false,
      descriptionLoaded: false,
      translatedDescriptionText: null,
      showOriginalDescription: false });

  }

  return (0, _reduxLoop.loop)(state, promise(detectDescriptionCall, action));
};

var handleDetectDescriptionLanguageSuccess = function handleDetectDescriptionLanguageSuccess(state, action) {return Object.assign({},
  state,
  action);};


var detectAdditionalInfoCall = function detectAdditionalInfoCall(_ref6) {var q = _ref6.q,locale = _ref6.locale;return _services.TranslationService.
  suggestStringLanguage(q, 0.7).
  then(function (detection) {
    if (detection) {
      return {
        targetAdditionalInfoLanguage: locale,
        sourceAdditionalInfoLanguage: detection.language,
        translatedAdditionalInfoRequired: detection.language !== locale };

    }

    return { translatedAdditionalInfoRequired: false };
  }).
  then(detectAdditionalInfoLanguageSuccess);};

var handleDetectAdditionalInfoLanguage = function handleDetectAdditionalInfoLanguage(state, action) {
  if (!action.q || !action.q.length) {
    return Object.assign({},
    state, {
      translatedAdditionalInfoRequired: false,
      additionalInfoLoaded: false,
      translatedAdditionalInfoText: null,
      showOriginalAdditionalInfo: false });

  }

  return (0, _reduxLoop.loop)(state, promise(detectAdditionalInfoCall, action));
};

var handleResetTranslate = function handleResetTranslate(state) {return Object.assign({},
  state, {
    translatedDescriptionRequired: null,
    descriptionLoaded: false,
    showOriginalDescription: false,
    translatedDescriptionText: null,
    targetDescriptionLanguage: null,
    sourceDescriptionLanguage: null,
    translatedAdditionalInfoRequired: null,
    additionalInfoLoaded: false,
    showOriginalAdditionalInfo: false,
    translatedAdditionalInfoText: null,
    targetAdditionalInfoLanguage: null,
    sourceAdditionalInfoLanguage: null });};


var handleDetectAdditionalInfoLanguageSuccess = function handleDetectAdditionalInfoLanguageSuccess(state, action) {return Object.assign({},
  state,
  action);};


var handleToggleDescriptionTranslation = function handleToggleDescriptionTranslation(state) {return Object.assign({},
  state, {
    showOriginalDescription: !state.showOriginalDescription });};


var handleToggleAdditionalInfoTranslation = function handleToggleAdditionalInfoTranslation(state) {return Object.assign({},
  state, {
    showOriginalAdditionalInfo: !state.showOriginalAdditionalInfo });};


var setPropertyOption = function setPropertyOption(properties, optionType) {return properties.map(function (property) {
    property.option_type = optionType;
    return property;
  });};

var fetchLoad = function fetchLoad(id) {return _axios2.default.get('agencies/' + id).
  then(loadCompanySuccess, loadCompanyFail);};

var fetchLoadOwnCompany = function fetchLoadOwnCompany(_ref7) {var companyId = _ref7.companyId,token = _ref7.token;return _axios2.default.
  get('agencies/' + companyId + '/my', { headers: { access_token: token } }).
  then(loadOwnCompanySuccess, loadOwnCompanyFail);};

var fetchCompanyProps = function fetchCompanyProps(id) {return Promise.all([
  _axios2.default.get('properties/search?agency_id=' + id + '&option=buy'),
  _axios2.default.get('properties/search?agency_id=' + id + '&option=rent'),
  _axios2.default.get('properties/search?agency_id=' + id + '&option=rent-short')]).

  then(function (response) {var
    dataForSell = response[0].data,dataForRent = response[1].data,dataForShortRent = response[2].data;
    return [].concat(
    setPropertyOption(dataForSell.data, 'buy'),
    setPropertyOption(dataForRent.data, 'rent'),
    setPropertyOption(dataForShortRent.data, 'rent-short'));

  }).
  then(loadCompanyPropsSuccess).
  catch(loadCompanyPropsFail);};

var submitCompanyContactUsForm = function submitCompanyContactUsForm(_ref8) {var is_community_member = _ref8.is_community_member,data = _objectWithoutProperties(_ref8, ['is_community_member']);return _axios2.default.
  post(is_community_member ? COMPANY_COMMUNITY_CONTACT_US_URL : COMPANY_CONTACT_US_URL, data).
  then(sendCompanyContactUsFormSuccess).
  catch(sendCompanyContactUsFormFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadOwnCompany = function handleLoadOwnCompany(state, _ref9) {var companyId = _ref9.companyId,token = _ref9.token;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoadOwnCompany, { companyId: companyId, token: token }));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref10) {var data = _ref10.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading company');
  error.status = response.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleLoadCompanyProps = function handleLoadCompanyProps(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    propertiesLoading: true }),
  promise(fetchCompanyProps, action));};

var handleLoadCompanyPropsSuccess = function handleLoadCompanyPropsSuccess(state, action) {return Object.assign({},
  state, {
    propertiesLoaded: true,
    propertiesLoading: false,
    propertiesError: null,
    properties: action });};


var handleLoadCompanyPropsFail = function handleLoadCompanyPropsFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed to get company propertiess');
  return Object.assign({},
  state, {
    propertiesLoaded: false,
    propertiesLoading: false,
    propertiesError: error });

};

var handleOpenCompanyContactModal = function handleOpenCompanyContactModal(state) {return Object.assign({},
  state, {
    mobileCompanyContactIsOpen: true });};


var handleCloseCompanyContactModal = function handleCloseCompanyContactModal(state) {return Object.assign({},
  state, {
    mobileCompanyContactIsOpen: false });};


var handleSendCompanyContactUsForm = function handleSendCompanyContactUsForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitted: false,
    formSubmitting: true }),
  promise(submitCompanyContactUsForm, action));};

var handleSendCompanyContactUsFormSuccess = function handleSendCompanyContactUsFormSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null,
    mobileCompanyContactIsOpen: false });};


var handleSendCompanyContactUsFormFail = function handleSendCompanyContactUsFormFail(state, _ref11) {var response = _ref11.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};


var handleReset = function handleReset(state) {return Object.assign({},
  initialState, {
    data: state.data,
    properties: state.properties });};


var company = (0, _reduxAct.createReducer)(function (on) {
  on(loadCompany, handleLoad);
  on(loadCompanySuccess, handleLoadSuccess);
  on(loadCompanyFail, handleLoadFail);
  on(loadOwnCompany, handleLoadOwnCompany);
  on(loadOwnCompanySuccess, handleLoadSuccess);
  on(loadOwnCompanyFail, handleLoadFail);
  on(loadCompanyProps, handleLoadCompanyProps);
  on(loadCompanyPropsSuccess, handleLoadCompanyPropsSuccess);
  on(loadCompanyPropsFail, handleLoadCompanyPropsFail);
  on(openCompanyContactModal, handleOpenCompanyContactModal);
  on(closeCompanyContactModal, handleCloseCompanyContactModal);
  on(sendCompanyContactUsForm, handleSendCompanyContactUsForm);
  on(sendCompanyContactUsFormSuccess, handleSendCompanyContactUsFormSuccess);
  on(sendCompanyContactUsFormFail, handleSendCompanyContactUsFormFail);
  on(translateDescription, handleTranslateDescription);
  on(translateDescriptionSuccess, handleTranslateDescriptionSuccess);
  on(translateDescriptionFail, handleTranslateDescriptionFail);
  on(translateAdditionalInfo, handleTranslateAdditionalInfo);
  on(translateAdditionalInfoSuccess, handleTranslateAdditionalInfoSuccess);
  on(translateAdditionalInfoFail, handleTranslateAdditionalInfoFail);
  on(detectDescriptionLanguage, handleDetectDescriptionLanguage);
  on(detectDescriptionLanguageSuccess, handleDetectDescriptionLanguageSuccess);
  on(detectAdditionalInfoLanguage, handleDetectAdditionalInfoLanguage);
  on(detectAdditionalInfoLanguageSuccess, handleDetectAdditionalInfoLanguageSuccess);
  on(toggleDescriptionTranslation, handleToggleDescriptionTranslation);
  on(toggleAdditionalInfoTranslation, handleToggleAdditionalInfoTranslation);
  on(resetTranslate, handleResetTranslate);
  on(reset, handleReset);
}, initialState);exports.


loadCompany = loadCompany;exports.
loadOwnCompany = loadOwnCompany;exports.
loadCompanyProps = loadCompanyProps;exports.
loadCompanySuccess = loadCompanySuccess;exports.
openCompanyContactModal = openCompanyContactModal;exports.
closeCompanyContactModal = closeCompanyContactModal;exports.
sendCompanyContactUsForm = sendCompanyContactUsForm;exports.
translateDescription = translateDescription;exports.
detectDescriptionLanguage = detectDescriptionLanguage;exports.
translateAdditionalInfo = translateAdditionalInfo;exports.
detectAdditionalInfoLanguage = detectAdditionalInfoLanguage;exports.
toggleDescriptionTranslation = toggleDescriptionTranslation;exports.
toggleAdditionalInfoTranslation = toggleAdditionalInfoTranslation;exports.
resetTranslate = resetTranslate;exports.
reset = reset;exports.default =


company;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/company.js
// module id = 281
// module chunks = 0